<div class="wrapper">
    <header *ngIf="isReady && !showLoader">
        <!-- <app-header></app-header> -->
         <app-new-header></app-new-header>
    </header>
    <main class="content-wrapper" *ngIf="isReady && !showLoader">
        <router-outlet></router-outlet>
        <app-footer *ngIf="!hideFooterOnRouterNav"></app-footer>
    </main>

    <div class="loader-container" *ngIf="showLoader">
        <div class="loader">
            <div class="loader-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </div>
</div>
